export const getMultiDayCampAvailability = details =>
  details?.isCamp && details?.repeat_id && Array.isArray(details?.multiDayCampAvailability?.days)
    ? details.multiDayCampAvailability
    : null;

export const canProgressFromMultiDayCampLink = details => {
  if (!details?.isCamp || !details?.repeat_id) return false;

  const availability = getMultiDayCampAvailability(details);
  return availability === null || availability.days.length > 0;
};

export const linkedCampOccurrenceIsUnavailable = details => {
  const availability = getMultiDayCampAvailability(details);
  return availability?.linkedOccurrenceAvailable === false;
};
